import {
    OreButton,
    OreHeading,
    OreModal,
    OreModalBox,
    OreModalBoxBody,
    OreModalBoxFooter,
    OreStack,
    OreText
} from "@edenredespana/oreneta"
import { Trans, useTranslation } from "react-i18next"
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useNavigate } from "react-router-dom"
import { useHelpCenter } from "@/HelpCenter/ui/context"
import { navigationRoutes } from '@/Shared/ui/routers'

interface NewTicketTPVModalProps {
    isModalOpen: boolean
    setIsModalOpen: (isOpen: boolean) => void
}

export const NewTicketTPVModal = ({ isModalOpen, setIsModalOpen }: NewTicketTPVModalProps): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { form, setStep, step } = useHelpCenter()

    const handleContinueClick = () => {
        setIsModalOpen(false)
        if(step === 2 && form.getValues().caseReasonDetailId === 116) {
            setStep(3)
        } else if (step === 3) {
            form.setValue('caseProductId', 0)
            setStep(2)
        }
    }
    const handleGoToPrivateAreaClick = () => {
        setIsModalOpen(false)
        form.reset()
        setStep(1)
        navigate(navigationRoutes.storeTPV)
    }

    return (
        <OreModal open={isModalOpen} handleOnClose={() => setIsModalOpen(false)}>
            <OreModalBox size="medium" handleOnClose={() => setIsModalOpen(false)}>
                <OreModalBoxBody>
                    <OreHeading size="headline-lg">
                        {t(HelpCenterTranslations.tpvModal.title)}
                    </OreHeading>
                    <OreText>
                        <Trans t={t}>
                            {t(HelpCenterTranslations.tpvModal.description)}
                        </Trans>
                    </OreText>
                </OreModalBoxBody>
                <OreModalBoxFooter>
                    <OreStack direction="row" placeItems="center" placeContent="end" space="medium">
                        <OreButton onClick={handleContinueClick} size="small" category="secondary">
                            {t(HelpCenterTranslations.tpvModal.continueButton)}
                        </OreButton>
                        <OreButton onClick={handleGoToPrivateAreaClick} size="small" category="primary">
                            {t(HelpCenterTranslations.tpvModal.privateAreaButton)}
                        </OreButton>
                    </OreStack>
                </OreModalBoxFooter>
            </OreModalBox>
        </OreModal>
    )
}
